/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../button/button.ngfactory';
import * as import2 from 'ionic-angular/components/button/button';
import * as import3 from 'ionic-angular/config/config';
import * as import4 from 'ionic-angular/components/radio/radio-button';
import * as import5 from 'ionic-angular/util/form';
import * as import6 from 'ionic-angular/components/item/item';
import * as import7 from 'ionic-angular/components/radio/radio-group';
const styles_RadioButton:any[] = ([] as any[]);
export const RenderType_RadioButton:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_RadioButton,
  data: {}
}
);
export function View_RadioButton_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'radio-icon'
      ]
      ],[[
        2,
        'radio-checked',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[' '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'radio-inner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[' '])),
    (l()(),import0.ɵted((null as any),[' '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'button',[
      [
        'class',
        'item-cover'
      ]
      ,
      [
        'ion-button',
        'item-cover'
      ]
      ,
      [
        'role',
        'radio'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
    ,[
      [
        8,
        'id',
        0
      ]
      ,
      [
        1,
        'aria-checked',
        0
      ]
      ,
      [
        1,
        'aria-labelledby',
        0
      ]
      ,
      [
        1,
        'aria-disabled',
        0
      ]

    ]
    ,(null as any),(null as any),import1.View_Button_0,import1.RenderType_Button)),
    import0.ɵdid(1097728,(null as any),0,import2.Button,[
      [
        8,
        'item-cover'
      ]
      ,
      import3.Config,
      import0.ElementRef,
      import0.Renderer
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted(0,[' ']))
  ]
  ,(null as any),(ck,v) => {
    var co:import4.RadioButton = v.component;
    const currVal_0:any = co._checked;
    ck(v,0,0,currVal_0);
    const currVal_1:any = co.id;
    const currVal_2:any = co._checked;
    const currVal_3:any = co._labelId;
    const currVal_4:any = co._disabled;
    ck(v,5,0,currVal_1,currVal_2,currVal_3,currVal_4);
  });
}
function View_RadioButton_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-radio',([] as any[]),[[
        2,
        'radio-disabled',
        (null as any)
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1)._click($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_RadioButton_0,RenderType_RadioButton)),
    import0.ɵdid(245760,(null as any),0,import4.RadioButton,[
      import5.Form,
      import3.Config,
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import6.Item
      ]
      ,
      [
        2,
        import7.RadioGroup
      ]

    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1)._disabled;
    ck(v,0,0,currVal_0);
  });
}
export const RadioButtonNgFactory:import0.ComponentFactory<import4.RadioButton> = import0.ɵccf('ion-radio',import4.RadioButton,View_RadioButton_Host_0,{
  color: 'color',
  mode: 'mode',
  value: 'value',
  checked: 'checked',
  disabled: 'disabled'
}
,{ionSelect: 'ionSelect'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/radio/radio-button.ngfactory.ts